import React from "react"

import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {NavigationButtonPosition} from "../../../core/model2/navigation/@const"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../components/hint/hint-section";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import Navigation_BaseButton from "./base-button";
import {featureAccess} from "../../../core/gd/access-control/feature-access/feature-access";
import {Feature} from "../../../core/gd/access-control/feature-access/const";

type Props = {
    className?          : string,
    section             : NavigationSection,
    onClickCallback?    : callback
    inMorePopover       : boolean
} & ReorderItemProps

export default class Navigation_ButtonAttendance extends React.Component<Props,any> {

    public refHint: React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    constructor(props: Props) {
        super(props);

        this.state = {
            status: false
        }
    }

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        const options = this.props.section.positionOptions

        if (_.size(options) < 1) {
            return null
        }

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )
    }

    componentDidMount() {
        gd.bus.subscribe("attendance:update", this, this.getStatus)
        this.getStatus()
    }

    getStatus = async ()=>{
        try{
            const status = await gd.session.attendanceStatus()

            this.setState({
                status: status
            })
        }
        catch (e: any){
            console.error(e)
        }
    }

    onClick = async () => {

        if (!featureAccess(Feature.ATTENDANCE)) {
            gd.modals.other.upgrade(Feature.ATTENDANCE)
            return
        }

        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        await gd.layout.navigation.openSectionV2(this.props.section)

        gd.goTo(this.props.section.defaultAppUrl || "clock-in-out")
    }

    render() {
        const isSelected = gd.layout.navigation.state.currentSection === this.props.section

        return (
            <Navigation_BaseButton className            = {this.props.className}
                                   icon                 = "i5-my-attendance"
                                   label                = "Attendance"
                                   style                = {this.props.style}
                                   isSelected           = {isSelected}
                                   dndPreview           = {this.props.dndPreview}
                                   dndIsDragged         = {this.props.dndIsDragged}
                                   inMorePopover        = {this.props.inMorePopover}
                                   dndIsDragInProgress  = {this.props.dndIsDragInProgress}
                                   isMouseEntered       = {this.props.isMouseEntered}
                                   onClick              = {this.onClick}
                                   showContextMenu      = {this.showContextMenu}>
                {this.props.section.position !== NavigationButtonPosition.MORE &&
                    <Navigation_ButtonHint ref={this.refHint} section={this.props.section}/>}
                <div className={Classes("btn-indicator", this.state.status ? "indicator-on" : "indicator-off")}></div>
            </Navigation_BaseButton>
        )
    }
}
